import React, { useState } from "react";
import MenuBottom from "../../Component/menuBottom/MenuBottom";
import MoveProduct from "../../Component/MoveProduct/MoveProduct";
import OrderProduct from "../../Component/OrderProduct/OrderProduct";
import Style from "./RequestDeliver.module.css";

const RequestDeliver = () => {
  const [checkedClass, setCheckdClass] = useState(false);
  const ClassHandler = () => {
    setCheckdClass(false);
  };
  const ClassHandler2 = () => {
    setCheckdClass(true);
  };
  let Content = null;
  if (checkedClass) {
    Content = <MoveProduct />;
  }
  if (!checkedClass) {
    Content = <OrderProduct />;
  }
  return (
    <div className={Style.PageHolder}>
      <header className={Style.TabsTitle}>
        <div
          className={checkedClass ? Style.normal : Style.checked}
          onClick={ClassHandler}
        >
          سفارش هوشمند کالا
        </div>
        <div
          className={checkedClass ? Style.checked : Style.normal}
          onClick={ClassHandler2}
        >
          جابجایی کالا
        </div>
      </header>
      {Content}
      <MenuBottom />
    </div>
  );
};

export default RequestDeliver;
